/**
 * Vue Router 配置
 */
import { createRouter, createWebHistory } from 'vue-router'
import { TokenManager } from '../api/tiktok'

// 路由组件
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Callback from '../views/Callback.vue'
import Upload from '../views/Upload.vue'
import TermsOfService from '../views/TermsOfService.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'

// 路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'TikTok 登录演示'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'TikTok 登录',
      requiresGuest: true // 只有未登录用户才能访问
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: '用户面板',
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload,
    meta: {
      title: '视频上传',
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback,
    meta: {
      title: '授权回调'
    }
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    component: TermsOfService,
    meta: {
      title: '服务条款'
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/'
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 检查认证状态
  const isLoggedIn = TokenManager.isLoggedIn()

  // 需要登录但未登录
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath }
    })
    return
  }

  // 只允许访客访问但已登录
  if (to.meta.requiresGuest && isLoggedIn) {
    next({ name: 'Dashboard' })
    return
  }

  next()
})

// 路由错误处理
router.onError((error) => {
  console.error('路由错误:', error)
})

export default router 